import gql from 'graphql-tag';

import { ClaimViewFields } from './fragments/claim';

export const ProcessClaim = gql`
  mutation ProcessClaim($input: GSTProcessClaimRequestInput!) {
    processClaim(input: $input) {
      result
      errorCode
      reasons
      claim {
        ...ClaimViewFields
      }
    }
  }
  ${ClaimViewFields}
`;
